import { useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from 'primereact/api';
import { InputText } from "primereact/inputtext";

import { useReport } from "../../context/report";

const TOLERANCIA = 1;

export default function CortesTecido() {
    const [globalFilter, setGlobalFilter] = useState("");
    const [filters, setFilters] = useState({
        global: { value: "", matchMode: FilterMatchMode.CONTAINS }
    });

    const { data } = useReport();

    const onGlobalFilterChange = e => {
        const value = e.target.value;

        setGlobalFilter(value);
        setFilters({
            global: { value, matchMode: FilterMatchMode.CONTAINS }
        });
    }

    const renderHeader = _ => {
        return (
            <div className="p-d-flex p-jc-end">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder="Pesquisar" />
                </span>
            </div>
        )
    }

    // Marca a linha quando orders tem mais metros que o SPI além da tolerância
    const rowClassName = row => {
        if (row.metros_spi === null || row.metros_spi === undefined) return '';
        const diff = Number(row.metros_tecido) - Number(row.metros_spi);
        return Math.abs(Math.round(diff * 100) / 100) > TOLERANCIA ? 'corte-divergente' : '';
    }

    return (
        <div>
            <style>{`
                .p-datatable .p-datatable-tbody > tr.corte-divergente > td {
                    background-color: #ffd6d6 !important;
                    color: #7a0000 !important;
                }
            `}</style>

            <DataTable
                emptyMessage="Nenhum resultado encontrado."
                filters={filters}
                globalFilterFields={["tear", "artigo", "rolo", "rolada", "metros_tecido", "metros_spi", "data_cortef"]}
                header={renderHeader}
                responsiveLayout="scroll"
                rowClassName={rowClassName}
                size="small"
                value={data}
            >
                <Column header="Tear" field="tear" sortable />
                <Column header="Artigo" field="artigo" sortable />
                <Column header="Rolo" field="rolo" sortable />
                <Column header="Rolada" field="rolada" sortable />
                <Column header="Metragem" field="metros_tecido" sortable />
                <Column header="Metragem SPI" field="metros_spi" sortable />
                {/* <Column header="Data Inicial" field="data_inicialf" sortable /> */}
                <Column header="Data Corte" field="data_cortef" sortable />
            </DataTable>
        </div>
    )
}